import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { centralizedHost, corporateHost } from "~/Utils";

interface DocumentDetailsResponse {
  id: number;
  title: string;
  title_malay: string;
  title_mandarin: string;
  key_info_type: any;
  image: any;
  published: any;
  module_name: any;
}

const fetchCentralizedKeyInfoListDetails = async (id: string): Promise<any> => {
  if (!id) {
    return null;
  }
  const response: any = await axios.get(`${centralizedHost}/api/key-info-group/all-fields/${id}`);
  return response.data[0];
};

const useCentralizedKeyInfoListDetails = (
  id: string,
  options?: UseQueryOptions<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<DocumentDetailsResponse, DefaultError> => {
  return useQuery<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>(
    {
      queryKey: ["centralizedKeyInfoList", id],
      enabled: false,
      queryFn: () => {
        return fetchCentralizedKeyInfoListDetails(id);
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { useCentralizedKeyInfoListDetails };
